import { render, staticRenderFns } from "./Fortschritt.vue?vue&type=template&id=9f67d1fc&"
import script from "./Fortschritt.vue?vue&type=script&lang=js&"
export * from "./Fortschritt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports